import {useEffect} from 'react';

import {SERVICE_NAME} from 'common/constants';

interface UseDocumentTitle {
    (title?: string): void;
}

const useDocumentTitle: UseDocumentTitle = (title) => {
    useEffect(() => {
        let currTitle = SERVICE_NAME;
        if (title) {
            currTitle = `${title} — ${SERVICE_NAME}`;
        }
        document.title = currTitle;
        return () => {
            document.title = SERVICE_NAME;
        };
    }, [title]);
};

export default useDocumentTitle;
